export default "__VITE_ASSET__e333660f__"